// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Njxtlo {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 400px;
}

.Aoq7Gi {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: var(--spacing-3, 24px);
  padding: var(--spacing-6, 48px) var(--spacing-3, 24px) var(--spacing-3, 24px);
}

.tCzGTU {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: var(--spacing-3, 24px);
  width: 100%;
}

.F37wjq {
  margin: 0;
  min-width: auto;
  width: 100%;
}

.sJHu3B {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: var(--spacing-3, 24px);
  margin: calc(-1 * var(--spacing-3, 24px));
}

.EoclZ7 {
  position: absolute;
  right: 24px;
  top: 64px;
  left: initial;
  width: 320px;
  min-width: initial;
  transform: initial;
}
`, "",{"version":3,"sources":["webpack://./../../packages/beneficios/src/pages/EmissorPaymentBankSlipPage/EmissorPaymentBankSlipPage.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,6EAA6E;AAC/E;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,SAAS;EACT,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  min-height: 400px;\n}\n\n.content {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: var(--spacing-3, 24px);\n  padding: var(--spacing-6, 48px) var(--spacing-3, 24px) var(--spacing-3, 24px);\n}\n\n.body {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--spacing-3, 24px);\n  width: 100%;\n}\n\n.bankSlipAnnotation {\n  margin: 0;\n  min-width: auto;\n  width: 100%;\n}\n\n.footer {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  padding: var(--spacing-3, 24px);\n  margin: calc(-1 * var(--spacing-3, 24px));\n}\n\n.alertMessage {\n  position: absolute;\n  right: 24px;\n  top: 64px;\n  left: initial;\n  width: 320px;\n  min-width: initial;\n  transform: initial;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Njxtlo`,
	"content": `Aoq7Gi`,
	"body": `tCzGTU`,
	"bankSlipAnnotation": `F37wjq`,
	"footer": `sJHu3B`,
	"alertMessage": `EoclZ7`
};
module.exports = ___CSS_LOADER_EXPORT___;
